/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType } from '../../shared/api/kyMutator';
import {
    type GoogleRpcStatus,
    type PayoutTraderOrderV1AcceptOrderRequest,
    type PayoutTraderOrderV1AcceptOrderResponse,
    type PayoutTraderOrderV1ApproveRequest,
    type PayoutTraderOrderV1ApproveResponse,
    type PayoutTraderOrderV1CountOrdersResponse,
    type PayoutTraderOrderV1DeclineOrderRequest,
    type PayoutTraderOrderV1DeclineOrderResponse,
    type PayoutTraderOrderV1FinalizeOrderRequest,
    type PayoutTraderOrderV1FinalizeOrderResponse,
    type PayoutTraderOrderV1GetOrderResponse,
    type PayoutTraderOrderV1ListOrdersResponse,
    type PayoutTraderOrderV1SplitOrderRequest,
    type PayoutTraderOrderV1SplitOrderResponse,
    type PayoutTraderOrderV1VerifyReceiptRequest,
    type PayoutTraderOrderV1VerifyReceiptResponse,
    type TraderPayoutOrderServiceCountOrdersParams,
    type TraderPayoutOrderServiceGetOrderParams,
    type TraderPayoutOrderServiceListOrdersParams,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить ордер по ID.
 */
export const getTraderPayoutOrderServiceGetOrderUrl = (params?: TraderPayoutOrderServiceGetOrderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order?${stringifiedParams}` : '/v1/order';
};

export const traderPayoutOrderServiceGetOrder = async (
    params?: TraderPayoutOrderServiceGetOrderParams,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1GetOrderResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1GetOrderResponse>(getTraderPayoutOrderServiceGetOrderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutOrderServiceGetOrderQueryKey = (params?: TraderPayoutOrderServiceGetOrderParams) => {
    return ['/v1/order', ...(params ? [params] : [])] as const;
};

export const getTraderPayoutOrderServiceGetOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutOrderServiceGetOrderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>> = ({ signal }) =>
        traderPayoutOrderServiceGetOrder(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutOrderServiceGetOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>
>;
export type TraderPayoutOrderServiceGetOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayoutOrderServiceGetOrderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить ордер по ID.
 */

export function useTraderPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutOrderServiceGetOrderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Получить ордера по заданным фильтрам.
 */
export const getTraderPayoutOrderServiceListOrdersUrl = (params?: TraderPayoutOrderServiceListOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
            'filter.priority',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : v.toString());
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders?${stringifiedParams}` : '/v1/orders';
};

export const traderPayoutOrderServiceListOrders = async (
    params?: TraderPayoutOrderServiceListOrdersParams,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1ListOrdersResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1ListOrdersResponse>(getTraderPayoutOrderServiceListOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutOrderServiceListOrdersQueryKey = (params?: TraderPayoutOrderServiceListOrdersParams) => {
    return ['/v1/orders', ...(params ? [params] : [])] as const;
};

export const getTraderPayoutOrderServiceListOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutOrderServiceListOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>> = ({ signal }) =>
        traderPayoutOrderServiceListOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutOrderServiceListOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>
>;
export type TraderPayoutOrderServiceListOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayoutOrderServiceListOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить ордера по заданным фильтрам.
 */

export function useTraderPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutOrderServiceListOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Попытаться взять ордер в работу.
Доступно только для ордеров в статусе STATUS_WAITING_REACTION.
 */
export const getTraderPayoutOrderServiceAcceptOrderUrl = () => {
    return '/v1/orders/accept';
};

export const traderPayoutOrderServiceAcceptOrder = async (
    payoutTraderOrderV1AcceptOrderRequest: PayoutTraderOrderV1AcceptOrderRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1AcceptOrderResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1AcceptOrderResponse>(getTraderPayoutOrderServiceAcceptOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1AcceptOrderRequest),
    });
};

/**
 * @summary Подтвердить выполнение ордера.
Доступно только для ордеров в статусе STATUS_IN_WORK.
Позволяет прекрепить идентификатор транзакции, если он был создан вне системы.
 */
export const getTraderPayoutOrderServiceApproveUrl = () => {
    return '/v1/orders/approve';
};

export const traderPayoutOrderServiceApprove = async (
    payoutTraderOrderV1ApproveRequest: PayoutTraderOrderV1ApproveRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1ApproveResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1ApproveResponse>(getTraderPayoutOrderServiceApproveUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1ApproveRequest),
    });
};

/**
 * @summary Получить количество ордеров по заданным фильтрам.
 */
export const getTraderPayoutOrderServiceCountOrdersUrl = (params?: TraderPayoutOrderServiceCountOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
            'filter.priority',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : v.toString());
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders/count?${stringifiedParams}` : '/v1/orders/count';
};

export const traderPayoutOrderServiceCountOrders = async (
    params?: TraderPayoutOrderServiceCountOrdersParams,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1CountOrdersResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1CountOrdersResponse>(getTraderPayoutOrderServiceCountOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutOrderServiceCountOrdersQueryKey = (params?: TraderPayoutOrderServiceCountOrdersParams) => {
    return ['/v1/orders/count', ...(params ? [params] : [])] as const;
};

export const getTraderPayoutOrderServiceCountOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutOrderServiceCountOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>> = ({ signal }) =>
        traderPayoutOrderServiceCountOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutOrderServiceCountOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>
>;
export type TraderPayoutOrderServiceCountOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayoutOrderServiceCountOrdersParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить количество ордеров по заданным фильтрам.
 */

export function useTraderPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayoutOrderServiceCountOrders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutOrderServiceCountOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Отказаться обрабатывать ордер.
Доступно только для ордеров в статусе STATUS_IN_WORK и для ордеров в STATUS_WAITING_REACTION
с приоритетом PRIORITY_HIGH.
 */
export const getTraderPayoutOrderServiceDeclineOrderUrl = () => {
    return '/v1/orders/decline';
};

export const traderPayoutOrderServiceDeclineOrder = async (
    payoutTraderOrderV1DeclineOrderRequest: PayoutTraderOrderV1DeclineOrderRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1DeclineOrderResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1DeclineOrderResponse>(getTraderPayoutOrderServiceDeclineOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1DeclineOrderRequest),
    });
};

/**
 * @summary Запустить проверку наличия чека и попытаться финализировать ордер трейдера.
 */
export const getTraderPayoutOrderServiceFinalizeOrderUrl = () => {
    return '/v1/orders/finalize';
};

export const traderPayoutOrderServiceFinalizeOrder = async (
    payoutTraderOrderV1FinalizeOrderRequest: PayoutTraderOrderV1FinalizeOrderRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1FinalizeOrderResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1FinalizeOrderResponse>(getTraderPayoutOrderServiceFinalizeOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1FinalizeOrderRequest),
    });
};

/**
 * @summary Проверить чек по данным ордера.
 */
export const getTraderPayoutOrderServiceVerifyReceiptUrl = () => {
    return '/v1/orders/receipt/verify';
};

export const traderPayoutOrderServiceVerifyReceipt = async (
    payoutTraderOrderV1VerifyReceiptRequest: PayoutTraderOrderV1VerifyReceiptRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1VerifyReceiptResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1VerifyReceiptResponse>(getTraderPayoutOrderServiceVerifyReceiptUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1VerifyReceiptRequest),
    });
};

/**
 * @summary Раздробить ордер в работе на две дочерние транзакции.
 */
export const getTraderPayoutOrderServiceSplitOrderUrl = () => {
    return '/v1/orders/split';
};

export const traderPayoutOrderServiceSplitOrder = async (
    payoutTraderOrderV1SplitOrderRequest: PayoutTraderOrderV1SplitOrderRequest,
    options?: RequestInit,
): Promise<PayoutTraderOrderV1SplitOrderResponse> => {
    return payoutKyMutator<PayoutTraderOrderV1SplitOrderResponse>(getTraderPayoutOrderServiceSplitOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderOrderV1SplitOrderRequest),
    });
};
